<template>
  <article class="card service-card mb-3">
    <div class="card-body service-card__body" :class="{ 'd-flex flex-column justify-content-center' : fixed }">
      <div class="service-card__image" v-if="!fixed"><slot/></div>
      <p class="service-card__title" :class="{ 'service-card__title--fixed' : fixed }" v-html="displayTitle"></p>
      <div class="service-card__details" :class="{ 'service-card__details--active' : open || fixed }">
        <ul class="service-card__list" v-if="details">
          <li v-for="detail in details" :key="detail">
            {{ detail }}
          </li>
        </ul>
        <slot name="body"></slot>
        <div v-if="fixed">
          <button class="btn btn-outline-more-info text-primary mb-0" @click="setFormService('I need a service not listed here')" data-toggle="modal" data-target="#getService">Send Us a Message</button>
        </div>
        <div class="service-card__contact" v-else>
          <p class="mb-0">{{ needThisText }}</p>
          <a target="_blank" class="btn btn-primary service-card__button" :href="buttonUrl" v-if="buttonUrl">{{ buttonText }}</a>
          <button class="btn btn-primary service-card__button" @click="setFormService(title)" data-toggle="modal" data-target="#getService" v-else>{{ buttonText }}</button>
        </div>
      </div>
      <button class="service-card__toggle" @click="toggleOpen()" v-if="!fixed">
        <span v-if="open">
          Hide Details <span class="fa fa-chevron-up"></span>
        </span>
        <span v-else>
          Show Details <span class="fa fa-chevron-down"></span>
        </span>
      </button>
    </div>
  </article>
</template>

<script>
  export default {
    name: 'service-card',
    props: {
      title: String,
      formattedTitle: String,
      needThisText: {
        type: String,
        default: "Need this service?"
      },
      details: Array,
      buttonText: {
        type: String,
        default: "Contact Us"
      },
      buttonUrl: {
        type: String,
        default: null
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: function() {
      return({
        open: false
      })
    },
    mounted() {
      this.$root.$on('service-card-toggled', (service_card) => {
        if (this == service_card) {
          this.open = !this.open
        } else {
          this.open = false
        }
      })
    },
    computed: {
      displayTitle() {
        if (this.formattedTitle) {
          return this.formattedTitle
        } else {
          return this.title
        }
      }
    },
    methods: {
      toggleOpen() {
        this.$root.$emit('service-card-toggled', this)
      },
      setFormService(option) {
        this.$root.$emit('set-form-service', option)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// service-card.vue